export const getProductListScopeKey = (values = {}) => {
    if (values.catalogueNumber) return `catalogue:${values.catalogueNumber}`;
    if (values.uuid) return `category:${values.uuid}`;
    return '';
};

export const buildProductSearchPayload = ({values = {}, criteria, aggsFilters, activeFilters, builder = false}) => {
    const payload = {
        body: criteria,
        aggsFilters,
        activeFilters,
        templates: values.templates,
        fieldsList: values.fieldsList,
        categories: values.categories,
        cardFieldsList: values.cardFieldsList
    };

    if (values.catalogueNumber) {
        payload.catalogueNumber = values.catalogueNumber;
    } else {
        payload.categoryUuid = values.uuid;
        payload.categoryUri = values.uri;
    }

    if (builder && !values.catalogueNumber && Array.isArray(values.previewProductIds)) {
        payload.productIds = values.previewProductIds;
    }

    return payload;
};
